<script>
// <template>
//   <div class="rt-header-button-group">
//     <slot />
//     <div v-if="showMore" ref="more" class="button-group-more">
//       <el-popover ref="popover" trigger="hover" popper-class="rtElPopover" @show="_showPopper">
//         <rt-button slot="reference" class="rt-button-more" icon-name="rt-base-more"></rt-button>
//       </el-popover>
//     </div>
//   </div>
// </template>
import RtButton from '../../button/rtButton';

export default {
  name: 'RtHeaderButtonGroup',
  components: {
    RtButton
  },
  props: {
    maxBtns: {
      type: Number,
      default: 3
    }
  },

  data () {
    return {
      visibleBtnClass: 'rt-header-button-group'
    };
  },

  methods: {
    /**
     * @deprecated
     * 方法已废弃
     */
    initButtons () {},

    /**
     * @deprecated
     * 方法已废弃
     */
    _renderVisibleButtons () {},

    /**
     * @deprecated
     * 方法已废弃
     */
    _renderPopperButtons () {},

    /**
     * @deprecated
     * 方法已废弃
     */
    _showPopper () {},

    /**
     * @deprecated
     * 方法已废弃
     */
    _getNodeList (nodes) {},

    /**
     * @deprecated
     * 方法已废弃
     */
    init () {
      // this.initButtons();
    },

    /**
     * @deprecated
     * 方法已废弃
     */
    removeBtns () {
      // this._renderVisibleButtons();
    },

    /**
     * @deprecated
     * 方法已废弃
     */
    moveBtns () {
      // this._showPopper();
    },

    /**
     * @deprecated
     * 方法已废弃
     */
    getNodeList (nodes) {
      // return this._getNodeList(nodes);
    }
  },

  render (h) {
    const moreBtn = h('rt-button', {
      class: 'rt-button-more',
      slot: 'reference',
      props: {
        'icon-name': 'rt-base-more'
      }
    });

    const btns = this.$slots.default ? this.$slots.default.filter(btn => btn.tag) : [];
    const visibleCount = btns.reduce((count, btn) => {
      const noSHow =
        btn.data &&
        btn.data.directives &&
        btn.data.directives.some(dire => dire.name === 'show' && dire.value === false);

      if (!noSHow) {
        count++;
      }
      return count;
    }, 0);

    const showMore = visibleCount > this.maxBtns;

    let visibleBtns, popoverMoreBtns;

    if (showMore) {
      let count = 0;
      const res = btns.reduce(
        (obj, btn) => {
          if (btn.tag && count < this.maxBtns) {
            count++;
            obj.visibleBtns.push(btn);
          } else {
            obj.popoverMoreBtns.push(btn);
          }

          return obj;
        },
        { visibleBtns: [], popoverMoreBtns: [] }
      );

      visibleBtns = res.visibleBtns;
      popoverMoreBtns = res.popoverMoreBtns;
    } else {
      visibleBtns = btns;
    }

    const moreBtnsDiv = h(
      'div',
      {
        class: 'rt-button-group-popper-wrapper'
      },
      popoverMoreBtns
    );

    const popover = h(
      'el-popover',
      {
        ref: 'popover',
        props: {
          'popper-class': 'rtElPopover',
          trigger: 'hover'
        }
      },
      [moreBtn, moreBtnsDiv]
    );

    if (visibleBtns.length === 1) {
      this.visibleBtnClass =
        'rt-header-button-group rt-button-group-visible-single';
    }

    return (
      <div class={this.visibleBtnClass}>
        {visibleBtns}
        {showMore && (
          <div ref="more" class="button-group-more">
            {popover}
          </div>
        )}
      </div>
    );
  }
};
</script>



// WEBPACK FOOTER //
// rtHeaderButtonGroup.vue?dd6991c6